import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import styles from "./ArenaDetails.module.css";
import Header from "../../dasboard-component/Components/HeaderMain";
import TextAds from "../../components/textAd.jsx";
import ImageVideoAds from "../../components/imageVideoAd.jsx";
import { Carousel } from "react-responsive-carousel";
import {
  FaChair,
  FaUsers,
  FaTimes,
  FaCertificate,
  FaPhone,
  FaUser,
  FaBriefcase,
  FaStar,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft, faQuoteRight } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../context/AuthContext";
import ImageModal from "../../common/FullScreenImageModal.jsx";

const ArenaDetails = ({ preview, selectTheSlot }) => {
  const { arenaId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [activeTab, setActiveTab] = useState("overview");
  const [modalImages, setModalImages] = useState([]);
  const [modalInitialIndex, setModalInitialIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentSlides, setCurrentSlides] = useState({});
  const [arenaSlides, setArenaSlides] = useState(0); // Track arena carousel slide
  const [companySlides, setCompanySlides] = useState(0); // Track company carousel slide
  const [adsSelected, setAdsSelected] = useState([]);
  const [currentAdIndexes, setCurrentAdIndexes] = useState({
    0: 0,
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
    6: 0,
  });

  const [selectedAd, setSelectedAd] = useState(null);
  const [ads, setAds] = useState([]);
  const { user } = useAuth();
  const [arena, setArena] = useState({
    id: 18,
    name: "Fast Arena",
    logo: "UklGRrorAABXRUJQVlA4IK4rAADQ1QCdASoNA+gAPm02l0ikI",
    about:
      "About the Arena About the Arena About the Arena About the Arena About the Arena About the Arena",
    telephone: "03105757512",
    address: {
      full_address: "house 23, Street 38 , isb, Pakistan",
      city: "isb",
      country: "Pakistan",
      plot_no: "house 23",
      street: "Street 38",
      area: "",
    },
    email: "admin@admin.com",
    sport: "Football",
    seating_capacity: 2,
    standing_capacity: 3,
    date_established: "2025-07-12T19:00:00.000Z",
    rating: {
      average: "3.0",
    },
    total_ratings: 1,
    reviews: [
      {
        rating: 3,
        comment: "jv",
        reviewer_name: "John Doe",
        date: "2025-07-17T15:52:38.000Z",
      },
    ],
    images: {
      arena_pictures: [
        "UklGRqaSAABXRUJQVlA4IJqSAADwRAKdASoABNABPm00lkekJ",
        "UklGRlo7AABXRUJQVlA4IE47AADw4wCdASoABIwAPm0ylkekI",
        "UklGRt69AABXRUJQVlA4INK9AADQiAGdASobAf4CPm0skUYkI",
        "UklGRiAPAABXRUJQVlA4IBQPAADwPgCdASoSAVoAPm0uk0akI",
      ],
      company_profile_photos: [
        "UklGRj4FAABXRUJQVlA4IDIFAABQIACdASr+AFUAPm0wlUakIyIhLxOZQIANiWJu4XKQ8FG/27exub/w/Kbcdam2J9hn+q+qH8Z7yjzAfsB/t/aQ9AHkZ+p3/ofYh/Zn2Ef1m9M79tPg2/cL0j9WyYrzw/nk/CiBHAy1b5z/pO/O/kvQD5TddFju8+v6F8+P0z7BP6y76qgIR5KnEMoGsI7E8mwtIP+x/2P+x/2P+x/GNY0MlQUi0HYZGH0B7cSYgoOtApESDoivtVBI5ZDSIEtivCWRdsVNHqxchmUCA2VN3Ick+c6oAauIshdAphYBX0HW6oAlQJlGGeLsvub8iGdOGMfhgeYBlcattKfPncgi3lMRaT09JrCknkc5WAAA/v8WCg5tSA/VC+OmiAKo4+tBM/UPKZXaxmfm/+z25pVP67bxzSxdB8RRN3OgLjpQpDDSOmlgCu4SDVS0JTg9NCGPGwS3R+6CY/+plj847/tyn9cP/vR1/10R33aYuEF0jzGkielqeLn7MLbX/18pgNPK5RS/2UX84UmTUHjBRXrBTaJsKBeeRyD/ckykHOQYeadKCYC4CF8AAaQPJS9fbdLMQQ44oywm6GnXRP9jmETtlcxS9qdg7HD5hnQtk+cgnYQtUMCAAA/v8WCg5tSA/VC+OmiAKo4…",
      ],
    },
    facilities: [
      {
        id: 25,
        sport:
          "Facility Detail Facility Detail Facility Detail Facility Detail Facility Detail Facility Detail",
        about:
          "Facility Detail Facility Detail Facility Detail Facility Detail Facility Detail Facility Detail Facility Detail",
        avg_rating: "3.0",
        seating_capacity: 300,
        standing_capacity: 400,
        rate: 2500,
        images: [
          "UklGRggUAABXRUJQVlA4IPwTAABw3QCdASoABNIBPm02mEkkIyKiIvEYqI",
          "UklGRt69AABXRUJQVlA4INK9AADQiAGdASobAf4CPm0skUYkI",
          "UklGRqQsAABXRUJQVlA4IJgsAADQDwGdASoABNYBPm02mEkkI",
        ],
      },
    ],
    licenses: [
      {
        title: "License Title",
        reference_number: "1234",
      },
    ],
    contacts: [
      {
        first_name: "Fast",
        middle_name: "khan",
        last_name: "Arena",
        email: "admin@admin.com",
        phone: "03105757512",
      },
    ],
    business_registration_number: "12103",
    tax_payer_number: "786",
    social_media: {
      facebook: "http://facebook.com",
      instagram: "http://instagram.com",
      twitter: "http://twitter.com",
    },
    website: "",
  });

  useEffect(() => {
    fetchArenaDetails();
  }, [arenaId]);

  useEffect(() => {
    if (preview) return;

    let isMounted = true;
    let timeoutId;

    const fetchAds = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/download-ad`,
          { withCredentials: true }
        );
        if (isMounted) setAds(response.data.ads);
      } catch (error) {
        console.error("Error fetching ads:", error);
      }

      if (isMounted) {
        timeoutId = setTimeout(fetchAds, 500);
      }
    };

    fetchAds();

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
  }, [preview]);

  const handleClicks = async (e, ad) => {
    if (preview) {
      const id = e.currentTarget.dataset.id;

      if (
        ((id === "ad-1" || id === "ad-2") && preview === "text") ||
        ((id === "ad-3" || id === "ad-5") && preview === "image") ||
        ((id === "ad-4" || id === "ad-6") && preview === "video")
      ) {
        setSelectedAd(id);
        selectTheSlot(id);
      }
    }

    e.preventDefault();

    if (!ad || !ad.url) return;
    window.location.href = ad.url;
    ad.clicks = ad.clicks + 1;

    try {
      const jsonData = {
        clicks: ad.clicks,
        id: ad.ids,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/upload-clicks`,
        jsonData,
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      if (response.data && response.data.success) {
      } else {
        throw new Error(response.data.message || "Failed to upload clicks");
      }
    } catch (error) {
      console.error("Error uploading clicks:", error);
      alert("Failed to upload Clicks: " + error.message);
    }
  };

  const convertDate = (dateString) => {
    const dateObj = new Date(dateString);

    dateObj.setDate(dateObj.getDate());

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  useEffect(() => {
    const getCurrentAds = () => {
      const now = new Date();
      const isoDate = now.toISOString().slice(0, 10); // "2025-06-17"
      const current_date = `${isoDate}T00:00:00`;
      const current_time = now.toTimeString().split(" ")[0];

      const newAds = [];

      for (const ad of ads) {
        const isDateInRange =
          ad.start_date.split("T")[0] <= current_date.split("T")[0] &&
          convertDate(current_date) <= ad.end_date.split("T")[0];

        const datePart = convertDate(current_date);
        const currentTime = new Date(`${datePart}T${current_time}`);
        const startTime = new Date(`${datePart}T${ad.start_time}`);
        const endTime = new Date(`${datePart}T${ad.end_time}`);
        const isTimeInRange =
          startTime <= currentTime && currentTime <= endTime;

        const isTimeIterRemaining = ad.total_time > 0;

        if (
          isDateInRange &&
          isTimeInRange &&
          isTimeIterRemaining &&
          ad.slotPlace.split(" ")[0] === "arenaDetailPage"
        ) {
          newAds.push(ad);
        }
      }

      if (JSON.stringify(adsSelected) !== JSON.stringify(newAds)) {
        const indexedAds = [];

        newAds.forEach((ad) => {
          const slotPlace = ad.slotPlace;
          const index = parseInt(slotPlace.trim().split(" ").pop(), 10);

          if (!isNaN(index)) {
            if (!indexedAds[index]) {
              indexedAds[index] = [];
            }
            indexedAds[index].push(ad);
          }
        });

        setAdsSelected(indexedAds);
      }
    };

    getCurrentAds();

    const interval = setInterval(() => {
      getCurrentAds();
    }, 1000);

    return () => clearInterval(interval);
  }, [ads]);

  const updateIterations = async (slot, i) => {
    if (!adsSelected[slot] || !adsSelected[slot][i]) return;

    try {
      const jsonData = {
        iterations: adsSelected[slot][i].iterations,
        total_time: adsSelected[slot][i].total_time,
        id: adsSelected[slot][i].ids,
        intervals: adsSelected[slot][i].intervals,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/upload-iterations`,
        jsonData,
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      if (response.data && response.data.success) {
      } else {
        throw new Error(response.data.message || "Failed to upload iterations");
      }
    } catch (error) {
      console.error("Error uploading iterations:", error);
      alert("Failed to upload Iterations: " + error.message);
    }
  };

  useEffect(() => {
    const timers = {};

    Object.keys(adsSelected).forEach((slotKey) => {
      const slot = parseInt(slotKey, 10);
      const adsInSlot = adsSelected[slot];
      const currentIndex = currentAdIndexes[slot];

      if (!adsInSlot || adsInSlot.length === 0 || currentIndex < 0) return;

      let nextIndex = currentIndex;

      const updateSlot = () => {
        // Update iterations if current ad is valid
        if (
          currentIndex < adsInSlot.length &&
          adsInSlot[currentIndex]?.iterations > 0
        ) {
          updateIterations(slot, currentIndex);
        }

        // Find next valid index with iterations > 0
        nextIndex = (currentIndex + 1) % adsInSlot.length;

        if (adsInSlot[nextIndex]?.iterations <= 0) {
          const originalIndex = nextIndex;
          while (
            adsInSlot[nextIndex]?.iterations <= 0 &&
            nextIndex !== currentIndex
          ) {
            nextIndex = (nextIndex + 1) % adsInSlot.length;
            if (nextIndex === originalIndex) break;
          }
        }

        // Prevent infinite loop if no valid ad is found
        if (adsInSlot[nextIndex]?.iterations <= 0) return;

        // Update index state
        setCurrentAdIndexes((prev) => ({
          ...prev,
          [slot]: nextIndex,
        }));
      };

      const interval =
        adsInSlot[currentIndex]?.iterations > 0
          ? adsInSlot[currentIndex]?.intervals
          : 1000;

      timers[slot] = setTimeout(updateSlot, interval);
    });

    return () => {
      // Clear all timers on cleanup
      Object.values(timers).forEach(clearTimeout);
    };
  }, [
    JSON.stringify(currentAdIndexes),
    JSON.stringify(
      Object.fromEntries(
        Object.entries(adsSelected).map(([slot, ads]) => [
          slot,
          ads.map((ad) => ad.iterations).join(","),
        ])
      )
    ),
  ]);

  const fetchArenaDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/user-dashboard/arena-details/${arenaId}`,
        { withCredentials: true }
      );
      setArena(response.data);
      console.log("Arena data set:", response.data);

      const initialSlides = {};
      response.data.facilities.forEach((facility, index) => {
        initialSlides[index] = 0;
      });
      setCurrentSlides(initialSlides);
    } catch (error) {
      console.error("Error fetching arena details:", error);
      setError("Failed to load arena details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const openGoogleMaps = () => {
    if (arena?.address?.coordinates) {
      const [lat, lng] = arena.address.coordinates
        .split(",")
        .map((coord) => parseFloat(coord.trim()));
      const url = `https://www.google.com/maps?q=${lat},${lng}`;
      window.open(url, "_blank");
    }
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={i} className={styles.starIcon} />);
    }

    if (hasHalfStar) {
      stars.push(
        <FaStar
          key="half"
          className={`${styles.starIcon} ${styles.halfStar}`}
        />
      );
    }

    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(
        <FaStar
          key={`empty-${i}`}
          className={`${styles.starIcon} ${styles.emptyStar}`}
        />
      );
    }

    return stars;
  };

  // Helper function to open modal with images
  const openImageModal = (images, initialIndex = 0) => {
    const imageArray = Array.isArray(images) ? images : [images];
    setModalImages(imageArray);
    setModalInitialIndex(initialIndex);
    setIsModalOpen(true);
  };

  const closeImageModal = () => {
    setIsModalOpen(false);
  };

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingSpinner}></div>
        <p>Loading arena details...</p>
      </div>
    );
  }

  if (error && !preview) {
    return (
      <div className={styles.errorContainer}>
        <i className="fas fa-exclamation-triangle"></i>
        <h2>Error</h2>
        <p>{error}</p>
        <button onClick={() => navigate(-1)} className={styles.backButton}>
          Go Back
        </button>
      </div>
    );
  }

  if (!arena) {
    return (
      <div className={styles.errorContainer}>
        <h2>Arena Not Found</h2>
        <p>The requested arena could not be found.</p>
        <button onClick={() => navigate(-1)} className={styles.backButton}>
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Header pageType="ArenaUserDashboard" />
      <div className={styles.containerText1}>
        {/* Text Ad Section */}
        <TextAds
          adsSelected={adsSelected}
          currentAdIndexes={currentAdIndexes}
          selectedAd={selectedAd}
          handleClicks={handleClicks}
          preview={preview}
          slot={1}
        />
        <div className={styles.mainContainer}>
          <main className={styles.main}>
            <div className="flex gap-2">
              <section
                className={`${styles.arenaHeader} ${styles.animateFadeIn}`}
              >
                <div className={styles.arenaInfo}>
                  {arena.logo && (
                    <img
                      src={`data:image/jpeg;base64,${arena.logo}`}
                      alt={arena.name}
                      className={`${styles.arenaLogo}`}
                      onClick={() => openImageModal(arena.logo, 0)}
                    />
                  )}
                  <div>
                    <h1 className={styles.arenaTitle}>{arena.name}</h1>
                    <div className={styles.rating}>
                      {arena && renderStars(parseFloat(arena.rating.average))}
                    </div>
                    <div className={styles.address}>
                      <i className="fas fa-map-marker-alt"></i>
                      <span>{arena.address.full_address}</span>
                    </div>
                    <div className={styles.detailsGap}></div>
                    {arena.about && (
                      <p className={styles.details}>{arena.about}</p>
                    )}
                  </div>
                </div>
                <button
                  onClick={openGoogleMaps}
                  className={styles.googleMapsButton}
                >
                  <i className="fas fa-map-marked-alt"></i> View on Google Maps
                </button>
              </section>
              <ImageVideoAds
                adsSelected={adsSelected}
                currentAdIndexes={currentAdIndexes}
                preview={preview}
                handleClicks={handleClicks}
                selectedAd={selectedAd}
                slot1={3}
                slot2={4}
              />
            </div>
            <section
              className={`${styles.tabsContainer} ${styles.animateFadeIn}`}
            >
              <nav className={styles.tabNav}>
                {[
                  {
                    id: "overview",
                    label: "Overview",
                    icon: "fas fa-info-circle",
                  },
                  {
                    id: "facilities",
                    label: "Facilities",
                    icon: "fas fa-dumbbell",
                  },
                  { id: "gallery", label: "Gallery", icon: "fas fa-images" },
                  { id: "reviews", label: "Reviews", icon: "fas fa-star" },
                  { id: "contact", label: "Contact", icon: "fas fa-phone" },
                  ...(arena.institute
                    ? [
                        {
                          id: "institute",
                          label: "Institute",
                          icon: "fas fa-building",
                        },
                      ]
                    : []),
                ].map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`${styles.tabButton} ${
                      activeTab === tab.id ? styles.activeTab : ""
                    }`}
                  >
                    <i className={tab.icon}></i>
                    {activeTab === tab.id && tab.label}
                  </button>
                ))}
              </nav>

              <div className={styles.tabContent}>
                {activeTab === "overview" && (
                  <div className={styles.overview}>
                    <div className={styles.infoGrid}>
                      <div className={`${styles.infoCard} `}>
                        <div className={styles.infoCardHeader}>
                          <i className="fas fa-calendar-alt"></i>
                          <h3>Established</h3>
                        </div>
                        <p>
                          {arena.date_established
                            ? new Date(
                                arena.date_established
                              ).toLocaleDateString()
                            : "N/A"}
                        </p>
                      </div>
                      <div className={`${styles.infoCard} `}>
                        <div className={styles.infoCardHeader}>
                          <i className="fas fa-building"></i>
                          <h3>Facilities</h3>
                        </div>
                        <p>
                          {arena.facilities.length} Sport
                          {arena.facilities.length !== 1 ? "s" : ""}
                        </p>
                      </div>
                      <div className={`${styles.infoCard} `}>
                        <div className={styles.infoCardHeader}>
                          <i className="fas fa-star"></i>
                          <h3>Rating</h3>
                        </div>
                        <div className={styles.ratingStart}>
                          {arena && (
                            <>
                              {renderStars(parseFloat(arena.rating.average))}
                              <span>{arena.rating.average}/5</span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    {arena.licenses.length > 0 && (
                      <div className={styles.licenses}>
                        <div className={styles.licensesGrid}>
                          {arena.licenses.map((license, index) => (
                            <div
                              key={index}
                              className={`${styles.licenseCard} `}
                            >
                              <div className={styles.infoCardHeader}>
                                <FaCertificate
                                  className={styles.infoCardIcon}
                                />
                                <h4>{license.title}</h4>
                              </div>
                              {license.reference_number && (
                                <p>Ref: {license.reference_number}</p>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {activeTab === "facilities" && (
                  <div className={styles.facilities}>
                    {arena.facilities.length > 0 ? (
                      <div className={styles.facilitiesGrid}>
                        {arena.facilities.map((facility, index) => (
                          <div key={index} className={`${styles.facilityCard}`}>
                            {facility.images && facility.images.length > 0 && (
                              <div className={styles.facilityImages}>
                                <Carousel
                                  showThumbs={false}
                                  autoPlay={true}
                                  showIndicators={false}
                                  infiniteLoop={true}
                                  interval={5000}
                                  stopOnHover={false}
                                  showStatus={false}
                                  showArrows={false}
                                  selectedItem={currentSlides[index] || 0}
                                  onChange={(slide) =>
                                    setCurrentSlides((prev) => ({
                                      ...prev,
                                      [index]: slide,
                                    }))
                                  }
                                >
                                  {facility.images.map((image, imgIndex) => (
                                    <div
                                      style={{ position: "relative" }}
                                      key={imgIndex}
                                      onClick={() =>
                                        openImageModal(
                                          facility.images,
                                          imgIndex
                                        )
                                      }
                                    >
                                      <img
                                        src={`data:image/jpeg;base64,${image}`}
                                        alt={`${facility.sport} ${
                                          imgIndex + 1
                                        }`}
                                        className={styles.facilityImage}
                                      />
                                    </div>
                                  ))}
                                </Carousel>
                                <div className={styles.customControlDots}>
                                  {facility.images.slice(0, 3).map((_, idx) => (
                                    <span
                                      key={idx}
                                      className={`${styles.customDot} ${
                                        currentSlides[index] === idx
                                          ? styles.active
                                          : ""
                                      }`}
                                      onClick={() =>
                                        setCurrentSlides((prev) => ({
                                          ...prev,
                                          [index]: idx,
                                        }))
                                      }
                                    />
                                  ))}
                                </div>
                              </div>
                            )}
                            <div className={styles.facilityDetail}>
                              <h3>
                                {facility.sport}
                                <div className={styles.facilityInfo}>
                                  <p>
                                    <FaChair style={{ color: "#0071bc" }} />{" "}
                                    Seating Capacity:{" "}
                                    <span>
                                      {facility.seating_capacity || "N/A"}
                                    </span>
                                  </p>
                                  <p>
                                    <FaUsers style={{ color: "#0071bc" }} />{" "}
                                    Standing Capacity:{" "}
                                    <span>
                                      {facility.standing_capacity || "N/A"}
                                    </span>
                                  </p>
                                </div>
                              </h3>
                              <p className={styles.extraFacility}>
                                {facility.about || "Unnamed Facility"}
                              </p>
                              <div className={styles.cardBottom}>
                                <h5>Rs {facility.rate || "N/A"} /hr</h5>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className={styles.emptyState}>
                        <i className="fas fa-dumbbell"></i>
                        <p>No facilities information available</p>
                      </div>
                    )}
                  </div>
                )}

                {activeTab === "gallery" && (
                  <div className={styles.gallery}>
                    {arena.images?.arena_pictures?.length > 0 && (
                      <div className={styles.albumSection}>
                        <h3 className={styles.albumTitle}>Arena Pictures</h3>
                        <div className={styles.carouselContainer}>
                          <Carousel
                            showThumbs={false}
                            autoPlay={true}
                            showIndicators={false}
                            infiniteLoop={true}
                            interval={5000}
                            stopOnHover={false}
                            showStatus={false}
                            showArrows={false}
                            selectedItem={arenaSlides}
                            onChange={(slide) => setArenaSlides(slide)}
                          >
                            {arena.images.arena_pictures.map((image, index) => (
                              <div
                                style={{ position: "relative" }}
                                key={index}
                                onClick={() =>
                                  openImageModal(
                                    arena.images.arena_pictures,
                                    index
                                  )
                                }
                              >
                                <img
                                  src={`data:image/jpeg;base64,${image}`}
                                  alt={`Arena ${index + 1}`}
                                  className={styles.galleryImage}
                                />
                              </div>
                            ))}
                          </Carousel>
                          <div className={styles.customControlDots}>
                            {arena.images.arena_pictures
                              .slice(0, 3)
                              .map((_, idx) => (
                                <span
                                  key={idx}
                                  className={`${styles.customDot} ${
                                    arenaSlides === idx ? styles.active : ""
                                  }`}
                                  onClick={() => setArenaSlides(idx)}
                                />
                              ))}
                          </div>
                        </div>
                      </div>
                    )}
                    {arena.images?.company_profile_photos?.length > 0 && (
                      <div className={styles.albumSection}>
                        <h3 className={styles.albumTitle}>
                          Company Profile Photos
                        </h3>
                        <div className={styles.carouselContainer}>
                          <Carousel
                            showThumbs={false}
                            autoPlay={true}
                            showIndicators={false}
                            infiniteLoop={true}
                            interval={5000}
                            stopOnHover={false}
                            showStatus={false}
                            showArrows={false}
                            selectedItem={companySlides}
                            onChange={(slide) => setCompanySlides(slide)}
                          >
                            {arena.images.company_profile_photos.map(
                              (image, index) => (
                                <div
                                  style={{ position: "relative" }}
                                  key={index}
                                  onClick={() =>
                                    openImageModal(
                                      arena.images.company_profile_photos,
                                      index
                                    )
                                  }
                                >
                                  <img
                                    src={`data:image/jpeg;base64,${image}`}
                                    alt={`Company ${index + 1}`}
                                    className={styles.galleryImage}
                                  />
                                </div>
                              )
                            )}
                          </Carousel>
                          <div className={styles.customControlDots}>
                            {arena.images.company_profile_photos
                              .slice(0, 3)
                              .map((_, idx) => (
                                <span
                                  key={idx}
                                  className={`${styles.customDot} ${
                                    companySlides === idx ? styles.active : ""
                                  }`}
                                  onClick={() => setCompanySlides(idx)}
                                />
                              ))}
                          </div>
                        </div>
                      </div>
                    )}
                    {!arena.images?.arena_pictures?.length &&
                      !arena.images?.company_profile_photos?.length && (
                        <div className={styles.emptyState}>
                          <i className="fas fa-images"></i>
                          <p>No images available</p>
                        </div>
                      )}
                  </div>
                )}

                {activeTab === "reviews" && (
                  <div className={styles.reviews}>
                    {arena.reviews.length > 0 ? (
                      arena.reviews.map((review, index) => (
                        <div key={index} className={`${styles.reviewCard} `}>
                          <div className={styles.reviewHeader}>
                            <div className={styles.reviewerInfo}>
                              <div className={styles.reviewerAvatar}>
                                {review.reviewer_name.charAt(0).toUpperCase()}
                              </div>
                              <div>
                                <h4>{review.reviewer_name}</h4>
                                <div className={styles.rating}>
                                  {renderStars(review.rating)}
                                </div>
                              </div>
                            </div>
                            <span className={styles.reviewDate}>
                              {new Date(review.date).toLocaleDateString()}
                            </span>
                          </div>
                          <p className={styles.reviewComment}>
                            {review.comment}
                          </p>
                        </div>
                      ))
                    ) : (
                      <div className={styles.emptyState}>
                        <i className="fas fa-star"></i>
                        <p>No reviews available</p>
                      </div>
                    )}
                  </div>
                )}

                {activeTab === "contact" && (
                  <div className={styles.contactSection}>
                    <div className={styles.contactGrid}>
                      <div className={`${styles.contactCard} `}>
                        <div className={styles.infoCardHeader}>
                          <FaPhone className={styles.contactIcon} />
                          <h3>Arena Information</h3>
                        </div>
                        <div className={styles.contactDetails}>
                          {arena.telephone && (
                            <div className={styles.contactItem}>
                              <span className={styles.contactLabel}>
                                Phone:
                              </span>
                              <span>{arena.telephone}</span>
                            </div>
                          )}
                          {arena.email && (
                            <div className={styles.contactItem}>
                              <span className={styles.contactLabel}>
                                Email:
                              </span>
                              <span>{arena.email}</span>
                            </div>
                          )}
                          {arena.website && (
                            <div className={styles.contactItem}>
                              <span className={styles.contactLabel}>
                                Website:
                              </span>
                              <a
                                href={arena.website}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.contactLink}
                              >
                                {arena.website}
                              </a>
                            </div>
                          )}
                          <div className={styles.socialMedia}>
                            <h4>Follow Us</h4>
                            <div className={styles.socialLinks}>
                              {arena.social_media?.facebook ? (
                                <a
                                  href={arena.social_media.facebook}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={`${styles.socialLink} ${styles.socialLinkFacebook}`}
                                >
                                  <i className="fab fa-facebook-f"></i>
                                </a>
                              ) : (
                                <span
                                  className={`${styles.socialLink} ${styles.socialLinkFacebook}`}
                                >
                                  <i className="fab fa-facebook-f"></i>
                                </span>
                              )}
                              {arena.social_media?.instagram ? (
                                <a
                                  href={arena.social_media.instagram}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={`${styles.socialLink} ${styles.socialLinkInstagram}`}
                                >
                                  <i className="fab fa-instagram"></i>
                                </a>
                              ) : (
                                <span
                                  className={`${styles.socialLink} ${styles.socialLinkInstagram}`}
                                >
                                  <i className="fab fa-instagram"></i>
                                </span>
                              )}
                              {arena.social_media?.twitter ? (
                                <a
                                  href={arena.social_media.twitter}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={`${styles.socialLink} ${styles.socialLinkTwitter}`}
                                >
                                  <i className="fab fa-twitter"></i>
                                </a>
                              ) : (
                                <span
                                  className={`${styles.socialLink} ${styles.socialLinkTwitter}`}
                                >
                                  <i className="fab fa-twitter"></i>
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className={`${styles.contactCard} `}>
                        <div className={styles.infoCardHeader}>
                          <FaBriefcase className={styles.contactIcon} />
                          <h3>Business Information</h3>
                        </div>
                        <div className={styles.businessGrid}>
                          {arena.business_registration_number && (
                            <div className={styles.businessItem}>
                              <span className={styles.contactLabel}>
                                Registration Number:
                              </span>
                              <p>{arena.business_registration_number}</p>
                            </div>
                          )}
                          {arena.tax_payer_number && (
                            <div className={styles.businessItem}>
                              <span className={styles.contactLabel}>
                                Tax Payer Number:
                              </span>
                              <p>{arena.tax_payer_number}</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={`${styles.contactCard}`}>
                      <div className={styles.infoCardHeader}>
                        <FaUser className={styles.contactIcon} />
                        <h3>Contact Persons</h3>
                      </div>
                      {arena.contacts.length > 0 ? (
                        <div className={styles.contactPersons}>
                          {arena.contacts.map((contact, index) => (
                            <div
                              key={index}
                              className={styles.contactPersonCard}
                            >
                              <div className={styles.contactPersonHeader}>
                                <div className={styles.contactAvatar}>
                                  {contact.first_name.charAt(0).toUpperCase()}
                                </div>
                                <h4>
                                  {contact.first_name}{" "}
                                  {contact.middle_name || ""}{" "}
                                  {contact.last_name}
                                </h4>
                              </div>
                              {contact.phone && (
                                <div className={styles.contactItem}>
                                  <span className={styles.contactLabel}>
                                    Phone:
                                  </span>
                                  <span>{contact.phone}</span>
                                </div>
                              )}
                              {contact.email && (
                                <div className={styles.contactItem}>
                                  <span className={styles.contactLabel}>
                                    Email:
                                  </span>
                                  <span>{contact.email}</span>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p className={styles.noContact}>
                          No contact information available
                        </p>
                      )}
                    </div>
                  </div>
                )}

                {activeTab === "institute" && arena.institute && (
                  <div className={styles.institute}>
                    <div className={`${styles.instituteCard}`}>
                      <div className={styles.instituteHeader}>
                        {arena.institute.logo && (
                          <img
                            src={`data:image/jpeg;base64,${arena.institute.logo}`}
                            alt={arena.institute.name}
                            className={styles.instituteLogo}
                          />
                        )}
                        <div>
                          <h2 className={styles.instituteName}>
                            {arena.institute.name}
                          </h2>
                          <p className={styles.instituteType}>
                            {arena.institute.institute_type_name}
                          </p>
                        </div>
                      </div>

                      <div className={styles.instituteDetails}>
                        <div className={styles.instituteInfo}>
                          <div className={styles.infoItem}>
                            <i className="fas fa-calendar-alt"></i>
                            <span>
                              Established:{" "}
                              {new Date(
                                arena.institute.date_established
                              ).toLocaleDateString()}
                            </span>
                          </div>

                          {arena.institute.telephone &&
                            arena.institute.telephone.length > 0 && (
                              <div className={styles.infoItem}>
                                <i className="fas fa-phone"></i>
                                <span>
                                  Phone:{" "}
                                  {Array.isArray(arena.institute.telephone)
                                    ? arena.institute.telephone.join(", ")
                                    : arena.institute.telephone}
                                </span>
                              </div>
                            )}

                          {arena.institute.website && (
                            <div className={styles.infoItem}>
                              <i className="fas fa-globe"></i>
                              <a
                                href={arena.institute.website}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.websiteLink}
                              >
                                {arena.institute.website}
                              </a>
                            </div>
                          )}
                        </div>

                        {arena.institute.about_institute && (
                          <div className={styles.instituteAbout}>
                            <h3>About the Institute</h3>
                            <p>{arena.institute.about_institute}</p>
                          </div>
                        )}

                        <div className={styles.instituteActions}>
                          <button
                            onClick={() =>
                              navigate(`/institutes/${arena.institute.id}`)
                            }
                            className={styles.viewDetailsButton}
                          >
                            View Institute Details
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </section>
          </main>
        </div>
        <ImageModal
          images={modalImages}
          initialIndex={modalInitialIndex}
          isOpen={isModalOpen}
          onClose={closeImageModal}
          alt="Arena"
          isBase64={true}
        />
      </div>
    </div>
  );
};

export default ArenaDetails;
